/**
 * In-memory photo store that replaces localForage for temporary photo staging.
 *
 * Photos only need to live from capture → API upload, so persistence across
 * page reloads is unnecessary. Using a plain Map avoids IndexedDB, which is
 * blocked in private/incognito browsing mode on Safari and Firefox.
 */
const store = new Map<string, File>();

export const photoStore = {
    setItem(id: string, file: File): Promise<File> {
        store.set(id, file);
        return Promise.resolve(file);
    },
    getItem(id: string): Promise<File | null> {
        return Promise.resolve(store.get(id) ?? null);
    },
    removeItem(id: string): Promise<void> {
        store.delete(id);
        return Promise.resolve();
    }
};
